import { render } from "./critical-milestone-indicator.vue?vue&type=template&id=6bb0c45e&scoped=true&ts=true"
import script from "./critical-milestone-indicator.vue?vue&type=script&lang=ts"
export * from "./critical-milestone-indicator.vue?vue&type=script&lang=ts"

import "./critical-milestone-indicator.vue?vue&type=style&index=0&id=6bb0c45e&lang=scss&scoped=true"
import "./critical-milestone-indicator.vue?vue&type=style&index=1&id=6bb0c45e&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb0c45e"]])

export default __exports__